namespace RioERP.Orders {
    export interface FranchiseePaymentsForm {
        FranchiseeId: Serenity.LookupEditor;
        PaymentDate: Serenity.DateEditor;
        PaidAmount: Serenity.DecimalEditor;
        PaymentMode: Serenity.EnumEditor;
        Remark: Serenity.StringEditor;
        PaymentRefNo: Serenity.StringEditor;
        BankName: Serenity.StringEditor;
        Comment: Serenity.StringEditor;
        ReceiptNo: Serenity.StringEditor;
    }

    export class FranchiseePaymentsForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.FranchiseePayments';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FranchiseePaymentsForm.init)  {
                FranchiseePaymentsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DateEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.EnumEditor;
                var w4 = s.StringEditor;

                Q.initFormType(FranchiseePaymentsForm, [
                    'FranchiseeId', w0,
                    'PaymentDate', w1,
                    'PaidAmount', w2,
                    'PaymentMode', w3,
                    'Remark', w4,
                    'PaymentRefNo', w4,
                    'BankName', w4,
                    'Comment', w4,
                    'ReceiptNo', w4
                ]);
            }
        }
    }
}
